import { FormProvider, UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { DatePicker } from "src/core/components/custom-ui/date-picker";
import { FormCombobox } from "src/core/components/custom-ui/form-combobox";
import { FormMultiSelect } from "src/core/components/custom-ui/form-multiselect";
import { Button } from "src/core/components/ui/button";
import { DialogFooter } from "src/core/components/ui/dialog";
import { ISelectOption } from "src/core/constants/options";
import { UpsertMissionFormValues } from "src/core/forms/missions/upsertMission.schema";
import { IMission } from "src/core/hooks/folder/useFolderMissions";

type UpsertMissionFormProps = {
  form: UseFormReturn<UpsertMissionFormValues>;
  onSubmit: (data: UpsertMissionFormValues) => void;
  isLoading: boolean;
  missionTypeWithRiskOptions: ISelectOption[];
  setOpen: (open: boolean) => void;
  setMissionToEdit: (mission: IMission | null) => void;
  isEdit: boolean;
};

export const UpsertMissionForm = ({
  form,
  onSubmit,
  isLoading,
  missionTypeWithRiskOptions,
  setOpen,
  setMissionToEdit,
  isEdit,
}: UpsertMissionFormProps) => {
  const { t } = useTranslation();

  return (
    <FormProvider {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)}>
        {isEdit ? (
          <FormCombobox
            control={form.control}
            name="missionType"
            required
            label={t("form.addMission.missionType")}
            options={missionTypeWithRiskOptions}
            withBadge
            isInModal={true}
          />
        ) : (
          <FormMultiSelect
            control={form.control}
            name="missionTypes"
            required
            label={t("form.addMission.missionType")}
            options={missionTypeWithRiskOptions}
            withBadge
          />
        )}
        <div className="w-1/2 mt-10">
          <DatePicker
            name="renewDate"
            required
            label={t("form.addMission.missionDate")}
            className="w-full"
            control={form.control}
            allowFutureDates={true}
            allowPastDates={false}
            minDate={new Date()}
          />
        </div>
        <DialogFooter>
          <Button type="submit" variant="default" className="ml-[20px]" loading={isLoading}>
            {t(isEdit ? "form.editMission.submit" : "form.addMission.submit")}
          </Button>
          <Button
            variant="link"
            onClick={(event) => {
              event.preventDefault();
              setOpen(false);
              setMissionToEdit(null);
              form.reset();
            }}
          >
            {t("global.form.cancel")}
          </Button>
        </DialogFooter>
      </form>
    </FormProvider>
  );
};
